import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';

@Block() @Component
export class ApartmentLocationMapBlock extends BaseBlock {
}

export default ApartmentLocationMapBlock;
